import React, {useContext, useEffect, useState} from 'react';
import axiosConfig from '../../../../Config/axios';
import {useParams} from "react-router";
import {useForm} from "react-hook-form";
import {Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import TextInput from "../../../../CommonElements/Input/TextInput";
import {Btn} from "../../../../AbstractElements";
import Loader from "../../../../Layout/Loader";
import AuthorizationContext from "../../../../_helper/Authorization";
import {UpdateUserFormProps, User, UpdateUserFormValues} from "../Types/UserTypes";
import type {AuthorizationContextType} from "../../../../_helper/Authorization/AuthorizationTypes";

type EditableUser = {
    id: number;
    name?: string;
    email?: string;
    disabled?: boolean;
    multimedia_id?: number | null;
    multimedia?: User['multimedia'];
};

const UpdateUserForm = ({callBack, userData}: UpdateUserFormProps) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const [user, setUser] = useState<EditableUser | null>((userData as EditableUser | null) || null);
    const [isDisabled, setIsDisabled] = useState(false);
    const params = useParams();
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const {
        handleSubmit,
        register,
        setError,
        clearErrors,
        formState: {errors},
        setValue,
    } = useForm<UpdateUserFormValues>();

    useEffect(() => {
        if (user) {
            setValue('name', user.name);
            setValue('email', user.email);
            const disabledValue = user.disabled || false;
            setValue('disabled', disabledValue);
            setValue('multimedia_id', user.multimedia_id || null);
            setIsDisabled(disabledValue);
        }
    }, [user, setValue]);

    useEffect(() => {
        if (!userData?.id) {
            setLoaderVisibility(true);
            axiosConfig
                .get(`/privilege/user/${params.user}`)
                .then((response: { data: { data: User; }; }) => {
                    if (response?.data?.data) {
                        setUser(response.data.data);
                    }
                    setLoaderVisibility(false);
                })
                .catch((exception: any) => {
                    errorHandler(exception);
                    setLoaderVisibility(false);
                });
        }
    }, [params.user, userData?.id, errorHandler]);

    const onSubmit = (data: UpdateUserFormValues) => {
        if (!user) return;
        clearErrors();
        setLoaderVisibility(true);

        // Ensure disabled is included as boolean
        const submitData = {
            ...data,
            disabled: isDisabled
        };

        axiosConfig
            .put(`/privilege/user/${user.id}`, submitData)
            .then((response: { data: { data: User; }; }) => {
                if (response?.data?.data) {
                    callBack && callBack(response.data.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError as any);
                setLoaderVisibility(false);
            });
    }

    return (
        <div>
            <Loader visibility={loaderVisibility}/>
            <Row className={'justify-content-center'}>
                <Col md={6}>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <TextInput name={'name'} type={'text'} label={'Name'} register={register}
                                   errors={errors} placeholder={'Name'} options={{required: true}}/>
                        <TextInput name={'email'} type={'email'} label={'Email'} register={register}
                                   errors={errors} placeholder={'Test@email.com'} options={{required: true}}/>
                        <FormGroup className="mb-3">
                            <div className="d-flex align-items-center">
                                <Label className="switch mb-0">
                                    <Input
                                        type="checkbox"
                                        checked={isDisabled}
                                        onChange={(e) => {
                                            setIsDisabled(e.target.checked);
                                            setValue('disabled', e.target.checked);
                                        }}
                                    />
                                    <span className="switch-state"></span>
                                </Label>
                                <Label className="mb-0 ms-2">Disable User</Label>
                            </div>
                        </FormGroup>

                        <Btn attrBtn={{
                            className: 'd-block w-100 mt-4',
                            color: 'primary',
                            type: 'submit',
                        }}>{'Update'}</Btn>
                    </Form>
                </Col>
            </Row>
        </div>
    );

}
export default UpdateUserForm;
